import { render, staticRenderFns } from "./Statics.vue?vue&type=template&id=2414cac8&scoped=true"
import script from "./Statics.vue?vue&type=script&lang=js"
export * from "./Statics.vue?vue&type=script&lang=js"
import style0 from "./Statics.vue?vue&type=style&index=0&id=2414cac8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2414cac8",
  null
  
)

export default component.exports